module.exports = __webpack_public_path__ + "static/media/gift_cards_dark.62293cda.svg";